module.exports = __webpack_public_path__ + "img/logoPMO.29596364.png";